<template>
	<c-dialog ref="dialog" width="450" @resolve="editHandle">
		<c-form ref="form" vertical unit-width="100%">
			<c-input type="hidden" name="id" ></c-input>
			<c-form-item label="不良品项编号" >
				<c-input name="defects_code" placeholder="请输入，忽略将自动生成" :disabled="editState"></c-input>
			</c-form-item>
			<c-form-item label="不良品项名称" required>
				<c-input name="defects_name"></c-input>
			</c-form-item>
		</c-form>
	</c-dialog>
</template>

<script>
export default {
	name: 'defectsEdit',
	
	data() {
		return {
			editState: false
		}
	},

	methods: {
		/*********打开编辑框，初始化**********/
		open(data) {
			this.editState = !!data;
			this.$refs.form.clear();
			if (data) {
				this.$refs.form.set(data);
			}
			//填充form表单
			this.$refs.dialog.open({
				title: data ? '编辑不良品项' : '创建不良品项'
			});
		},

		/*******创建、编辑提交处理方法********/
		editHandle (stop, next){
			stop();
			this.$refs.form.submit({
				url: this.editState?'/dic/defects/edit':'/dic/defects/add',
				rule: {
					defects_name: '请输入不良品项名称'
				},
				dataFormatter: data => {
					return data;
				},
				success: (data, res) => {
					next();
					this.$message({
						message: '提交成功',  // 提示内容,
						type: 'success'
					});
					this.$emit('resolve');
				}
			});
		}
	}
}
</script>

<style lang="stylus" scoped>
</style>